import { gql } from '@apollo/client';

/**
 * 包裹差异 tab「下载数据」mutation：每行 = 一个 bag。
 */
export const GENERATE_WORK_PROGRESS_BAG_DETAIL_DOWNLOAD_REPORT = gql`
  mutation GenerateWorkProgressBagDetailDownloadReport(
    $filter: WorkProgressBagDetailExportFilterInput!
    $timezone: String
  ) {
    generateWorkProgressBagDetailDownloadReport(filter: $filter, timezone: $timezone)
  }
`;

export interface WorkProgressBagDetailExportFilterInput {
  hubId: number;
  arrivalDateStart: string;
  arrivalDateEnd: string;
  /** 默认 1=有提单号 */
  bagType?: number;
  customerId?: number | null;
  mawb?: string | null;
}

export interface GenerateWorkProgressBagDetailDownloadReportVariables {
  filter: WorkProgressBagDetailExportFilterInput;
  timezone?: string;
}

export interface GenerateWorkProgressBagDetailDownloadReportResponse {
  generateWorkProgressBagDetailDownloadReport: string;
}
